import { Route, Routes } from "react-router-dom";
import styles from "./App.module.css";
import Home from "./components/Home";

export default function App() {
  return (
    <div className={styles.main}>
      <div className={styles.content}>
        <Routes>
          <Route path="" element={<Home />}></Route>
        </Routes>
      </div>
    </div>
  );
}
